import * as React from 'react';
import { toast } from 'react-toastify';
import { MdClose } from 'react-icons/md';
import { ReactNode } from 'react';

const CustomCloseButton = (toastProps: any) => {
  const { closeToast, ...validProps } = toastProps;
  return <MdClose {...validProps} />;
};

export enum AutoCloseDuration {
  Default = 5000,
  Longer = 10000
}

const defaultConfiguration = {
  position: toast.POSITION.TOP_LEFT,
  autoClose: 5000,
  closeButton: <CustomCloseButton />,
  zIndex: '2001',
  icon: false
};

export const toastFactory = (configuration?: any) => {
  let toastId = null;

  const config = {...defaultConfiguration, ...configuration};

  return {
    dispatch: (message: string, type: string = toast.TYPE.INFO) => toastId = toast(message || '', {
      ...config,
      type
    }),

    success: (message: ReactNode | HTMLElement | string) => {
      return toastId && toast.update(toastId, {
        ...config,
        render: message,
        type: toast.TYPE.SUCCESS
      });
    },

    error: (message: ReactNode | HTMLElement | string) => {
      return toastId && toast.update(toastId, {
        ...config,
        render: message,
        type: toast.TYPE.ERROR
      });
    },

    close: () => {
      return toastId && toast.dismiss(toastId);
    }
  };
};
